// import { FormattedMessage } from "react-intl";
import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
// import NewsletterForm from "./components/NewsletterForm";
import spradlingLogo from "./img/spradling_logo_gray.svg";
import "./style/footer.scss";

export default function Footer() {
  return (
    <div className="Footer mt-4">
      {/* <div className="container-form bg-gray pb-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 py-3">
              <div className="form-group desktop">
                <h6>
                  <FormattedMessage
                    id="Footer.followUs"
                    defaultMessage="Follow Us"
                  />
                </h6>
                <ul>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/SpradlingEurope"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/spradlingeurope/"
                    >
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.linkedin.com/company/spradling-europe"
                    >
                      Linkedin
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3"></div>
            <div className="col-md-3 py-3"><NewsletterForm /></div>
          </div>
          <div className="followus">
            <h6>
              <FormattedMessage
                id="Footer.followUs"
                defaultMessage="Follow Us"
              />
            </h6>
            <ul className="without-spacing">
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/SpradlingEurope"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/spradlingeurope/"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/company/spradling-europe"
                >
                  Linkedin
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="container-form py-2">
        <div className="footer-logo my-3">
          <div className="d-flex align-items-end">
            <img src={spradlingLogo} style={{ maxHeight: "25px" }} alt="..." />
            <span className="small">&copy; 2023 Spradling Europe</span>
          </div>
          <div className="desktop">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/SpradlingEurope"
            >
              <FaFacebookF color="gray" className="fs-4 me-2" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/spradlingeurope/"
            >
              <FaInstagram color="gray" className="fs-4 me-2" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/spradling-europe"
            >
              <FaLinkedin color="gray" className="fs-4 me-2" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
